import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PageLayout } from '@hero/components/layouts';
import { ROUTE_PATHS } from '@hero/routes';

import { AIGiftAssistantTemplateForm } from './AIGiftAssistantTemplateForm';
import { AIGiftAssistantTemplateResults } from './AIGiftAssistantTemplateResults';

const AI_STEP = {
  search: 'search',
  results: 'results'
};
export function AIGiftAssistantTemplate() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [aiStep, setAiStep] = useState(AI_STEP.search);

  return (
    <PageLayout
      header={{
        title: t('aiGiftAssistant')
      }}
      navigation={{
        leftButton: {
          children: t('goBackToTemplates'),
          onClick: () => navigate(ROUTE_PATHS.SEND_GIFT_OCCASIONS)
        }
      }}
    >
      <AnimatePresence mode="wait">
        {aiStep === AI_STEP.search ? (
          <motion.div
            key="search"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
          >
            <AIGiftAssistantTemplateForm setAiStep={setAiStep} />
          </motion.div>
        ) : (
          <motion.div
            key="results"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
          >
            <AIGiftAssistantTemplateResults setAiStep={setAiStep} />
          </motion.div>
        )}
      </AnimatePresence>
    </PageLayout>
  );
}
